export const showModal = {
  methods: {
    showModal (i) {
      this.$store.dispatch('SHOW_MODAL', true)
      this.$store.dispatch('VIEW_MODALCONTENT', i)
      this.$store.state.showModal ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    }
  }
}

export const closeModal = {
  methods: {
    closeModal () {
      this.$store.dispatch('SHOW_MODAL', false)
      this.$store.dispatch('VIEW_MODALCONTENT', false)
      document.body.classList.remove('body-stop')
      this.drawerOpen ? '' : this.$store.dispatch('VIEW_DRAWER', false)
    }
  }
}

export const toggleMenu = {
  methods: {
    toggleMenu () {
      this.$store.state.drawer = !this.$store.state.drawer
      this.drawerOpen ? document.body.classList.add('body-stop') : document.body.classList.remove('body-stop')
    }
  }
}

export const showTab = {
  data () {
    return {
      tab: 0
    }
  },
  methods: {
    showTab (i) {
      this.tab = i
    }
  }
}

export const moveTo = {
  methods: {
    moveTo (i) {
      this.$options.parent.$refs.home.$fullpage.moveTo(i, true)
    }
  }
}



// WEBPACK FOOTER //
// ./src/mixins.js